import Base from '../../../Core/Base.js';

/**
 * @module Grid/feature/mixin/SummaryFormatter
 */

/**
 * Mixin for Summary and GroupSummary that handles formatting sums.
 * @mixin
 * @private
 */
export default Target => class SummaryFormatter extends (Target || Base) {
    static get $name() {
        return 'SummaryFormatter';
    }

    /**
     * Calculates sums and returns as a html table
     * @param {Grid.column.Column} column Column to calculate sum for
     * @param {Core.data.Model[]} records Records to include in calculation
     * @param {String} cls CSS class to apply to summary table
     * @param {Core.data.Model} groupRecord current group row record
     * @param {String} groupField Current groups field name
     * @param {String} groupValue Current groups value
     * @returns {String} html content
     */
    generateHtml(column, records, cls, groupRecord, groupField, groupValue) {
        const
            store = this.store,
            summaries = column.summaries ||
                  (column.sum ? [{ sum : column.sum, renderer : column.summaryRenderer }] : []);

        let html = `<div class="b-summary-wrap ${cls}">`;

        summaries.forEach(config => {
            let type = config.sum,
                sum  = null;

            if (type === true) type = 'sum';

            switch (type) {
                case 'sum':
                case 'add':
                    sum = store.sum(column.field, records);
                    break;
                case 'max':
                    sum = store.max(column.field, records);
                    break;
                case 'min':
                    sum = store.min(column.field, records);
                    break;
                case 'average':
                case 'avg':
                    sum = store.average(column.field, records);
                    break;
                case 'count':
                    sum = records.length;
                    break;
                case 'countNotEmpty':
                    sum = records.reduce((sum, record) => {
                        const value = record.getValue(column.field);
                        return sum + (value != null ? 1 : 0);
                    }, 0);
                    break;
            }

            if (typeof type === 'function') {
                sum = records.reduce(type, 'seed' in config ? config.seed : 0);
            }

            if (sum !== null) {
                const
                    valueCls  = 'b-grid-summary-value',
                    // optional label
                    labelHtml = config.label
                        ? `<div class="b-grid-summary-label">${config.label}</div>`
                        : '';

                // value to display, either using renderer or as is
                let valueHtml = config.renderer
                        ? config.renderer({ config, sum })
                        : sum,
                    summaryHtml;

                if (valueHtml == null) {
                    valueHtml = '';
                }

                // no <div>s in html, wrap it (always the case when not using renderer)
                if (!String(valueHtml).includes('<div>')) {
                    summaryHtml = labelHtml
                        // has label, use returned html as value cell
                        ? `${labelHtml}<div class="${valueCls}">${valueHtml}</div>`
                        // no label, span entire table
                        : `<div class="${valueCls} b-nolabel">${valueHtml}</div>`;
                }
                // user is in charge of giving correct formatting
                else {
                    summaryHtml = valueHtml;
                }

                html += summaryHtml;
            }
        });

        return `${html}</div>`;
    }
};
